<template>
  <v-card
    v-if="reload"
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('customer&detail') }} </v-toolbar-title>
      <v-spacer />
      <v-checkbox
        v-model="status"
        class="mt-5  mx-3"
        :label="$t('active')"
        value="active"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo('customer')"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('newCustomer') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'customerList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('customerList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab>{{ $t('public-information') }}</v-tab>
        <v-tab v-if="activeUser">
          {{ $t('userInformation') }}&{{$t('access')}}
        </v-tab>
        <v-tab>{{ $t('Integrator') }}</v-tab>
        <v-tab
          :disabled="documentPermmission"
        >
          {{ $t('documents') }}
        </v-tab>
        <v-tab-item>
          <v-container>
            <v-row class="pt-1">
              <v-col
                cols="12"
                md="1"
              >
                <v-row>
                  <v-col
                    cols="12"
                    :class="{'mb-6' : $vuetify.breakpoint.mobile}"
                  >
                    <file-picker
                      ref="refFilePicker"
                      v-model="imagePicker"
                      :label="$t('uploadImage')"
                      :avatar="true"
                      :multiple="false"
                      extensions="image/png, image/gif, image/jpeg"
                      type-prop="personAvatar"
                      :val="(imagePickerVal ? imagePickerVal : null)"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                class="ps-0"
                md="11"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-btn-toggle
                      v-model="gender"
                      mandatory
                      dense
                    >
                      <v-btn
                        value="man"
                        height="35"
                        style="color: #2b2b2b"
                      >
                        {{$t('man')}}
                      </v-btn>
                      <v-btn
                        style="color: #2b2b2b"
                        value="woman"
                        height="35"
                      >
                        {{$t('woman')}}
                      </v-btn>
                      <v-btn
                        style="color: #2b2b2b"
                        value="company"
                        height="35"
                      >
                        {{$t('legal')}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col md="1">
                    <v-checkbox
                      v-model="lead"
                      class="mt-0"
                      :label="$t('lead')"
                      value="active"
                      :disabled="(personel == 'active' ? true : false)"
                    />
                  </v-col>
                  <v-col md="1">
                    <v-checkbox
                      v-model="personel"
                      class="mt-0"
                      :label="$t('user')"
                      value="active"
                      :disabled="(lead == 'active' ? true : false)"
                    />
                  </v-col>
                  <v-col
                    v-if="$store.state.learningSystem === 'active'"
                    md="2"
                    class="d-flex"
                  >
                    <v-checkbox
                      v-model="student"
                      class="mt-0"
                      :label="$t('student', {name: $store.state.studentLabel})"
                      value="active"
                      :disabled="(lead == 'active' ? true : false)"
                    />
                    <v-checkbox
                      v-model="teacher"
                      class="mt-0 ms-2"
                      :label="$t('teacher')"
                      value="active"
                      :disabled="(lead == 'active' ? true : false)"
                    />
                  </v-col>
                  <v-col
                    v-if="$store.state.allConfig && $store.state.allConfig.commissionSystem == 'active'"
                    md="2"
                    class="d-flex"
                  >
                    <v-checkbox
                      v-model="visitor"
                      class="mt-0 ms-2"
                      :label="$t('visitor')"
                      value="active"
                      :disabled="(lead == 'active' ? true : false)"
                    />
                  </v-col>
                  <v-col
                    v-if="$store.state.allConfig && $store.state.allConfig.investorSystem == 'active'"
                    md="2"
                    class="d-flex"
                  >
                    <v-checkbox
                      v-model="investor"
                      class="mt-0 ms-2"
                      :label="$t('investor')"
                      value="active"
                      :disabled="(lead == 'active' ? true : false)"
                    />
                  </v-col>
                  <v-col
                    v-if="$store.state.translationSystem === 'active'"
                    md="1"
                  >
                    <v-checkbox
                      v-model="translator"
                      class="mt-0"
                      :label="$t('translator')"
                      value="active"
                      :disabled="(lead == 'active' ? true : false)"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="firstname"
                      :label="$t('name')"
                      :rules="[
                        v => !!v || $t('is-required'),
                        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                      ]"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    v-show="gender !== 'company'"
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="lastname"
                      :label="$t('last-name')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="nationalCode"
                      :label="$t('national-code')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="mobile"
                      :label="$t('mobile')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="panel"
              class="mt-8"
            >
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t('otherCantactInfo') }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t('email') }} , {{$t('phone')}} , {{$t('address')}} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="email"
                        :label="$t('email')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="phone"
                        :label="$t('phone')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <aicomplete
                        ref="refCountry"
                        v-model="country"
                        title="country"
                        type="country"
                        :val="country"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <aicomplete
                        ref="refState"
                        v-model="state"
                        title="state"
                        type="state"
                        :val="state"
                        :new-btn="true"
                        :data="JSON.stringify({parent:(country ? country.id : null)})"
                        :parent="(country ? country.id : null)"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <aicomplete
                        ref="refCity"
                        v-model="city"
                        title="city"
                        type="city"
                        :val="city"
                        :new-btn="true"
                        :data="JSON.stringify({parent:(country ? country.id : null)})"
                        :parent="(state ? state.id : null)"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="address"
                        outlined
                        clearable
                        dense
                        :label="$t('address')"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-map-marker
                          </v-icon>
                          <!--                    <div class="mt-1">-->
                          <!--                      {{(country ? country.name : '')}}-->
                          <!--                      {{(state ? ' - ' + state.name : '')}}-->
                          <!--                      {{(city ? ' - ' + city.name + ' - ' : '')}}-->
                          <!--                    </div>-->
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="postalCode"
                        :label="$t('postal-code')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t('grouping,tags') }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t('tag') }} , {{$t('category')}} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <aicomplete
                        ref="refCategory"
                        v-model="category"
                        title="category"
                        type="accountCategory"
                        :val="category"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <tag
                        v-model="tag"
                        :solo="false"
                        :input="tag"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t('otherIdentityInformation') }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t('birthDate') }} , {{$t('financial-code')}} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="businessName"
                        :label="$t('business-name')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="financialCode"
                        :label="$t('financial-code')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <template>
                        <v-text-field
                          id="date"
                          v-model="birthDate"
                          :label="$t('birthDate')"
                          single-line
                          clear-icon="flaticon2-close-cross"
                          outlined
                          dense
                          clearable
                        />

                        <date-picker
                          v-model="birthDate"
                          element="date"
                          auto-submit
                          :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                        />
                      </template>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-show="$store.state.isMainYear">
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t('financialInformation') }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t('initialRemainingAndFinancialStatus')}}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-select
                        v-model="nature_initial_price"
                        :label="$t('natureAccount')"
                        :items="natureItems"
                        height="30"
                        dense
                        outlined
                        :disabled="!initialCheck"
                        item-value="value"
                        item-text="text"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <money
                        v-model="initial_price"
                        :label="$t('initialPrice')"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty=""
                        :options="options"
                        :disabled="!initialCheck"
                        class="mb-3 dense"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="!isMobile && customFieldsPermission">
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div> {{ $t('customFields') }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t('customeFeildDescrible')}}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <custom-fields
                    v-model="customFields"
                    :value="customFields"
                    typeProp="accountCustomFields"
                    class="px-4"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t('otherInformation') }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t('branch') }} , {{ $t('content') }} , {{$t('attractionMethod')}} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <aicomplete
                        v-model="branch"
                        title="branch"
                        type="branch"
                        :set-init="true"
                        :val="branch"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col md="3">
                      <autocomplete
                        v-model="attractionMethod"
                        :title="$t('attractionMethod')"
                        type="attractionMethod"
                        :value="attractionMethod"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <description
                        v-model="content"
                        :outlined="true"
                        type="sell"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-tab-item>
        <v-tab-item v-if="activeUser">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="username"
                  :label="$t('username')"
                  outlined
                  clearable
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="password"
                  :label="$t('password')"
                  :type="(showPassword ? 'text' : 'password')"
                  outlined
                  clearable
                  dense
                  :append-icon="(showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline')"
                  @click:append="showPassword = !showPassword"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <autocomplete
                  ref="refRole"
                  v-model="role"
                  :title="$t('userRole')"
                  type="role"
                  :set-init="true"
                  :value="role"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-btn-toggle
                  v-model="personnelType"
                  mandatory
                  dense
                >
                  <v-btn
                    value="personnel"
                    height="35"
                    style="color: #2b2b2b"
                  >
                    {{$t('personnel')}}
                  </v-btn>
                  <v-btn
                    style="color: #2b2b2b"
                    value="customer"
                    height="35"
                  >
                    {{$t('customer')}}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="3"
                class="mb-2"
              >
                <autocomplete
                  ref="refEntrepot"
                  v-model="entrepotAccess"
                  :title="$t('entrepotAccess')"
                  :multiple="true"
                  :value="entrepotAccess"
                  :data="JSON.stringify({withoutAccess : 'active'})"
                  type="entrepot"
                  :disabled="(!$store.state.access ? true : false)"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="mb-2"
              >
                <aicomplete
                  v-model="branchAccess"
                  title="branch"
                  type="branch"
                  :val="branchAccess"
                  :multiple="true"
                  :new-btn="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="mb-2"
              >
                <autocomplete
                  v-model="departmentAccess"
                  :title="$t('departmentAccess')"
                  :multiple="true"
                  :value="departmentAccess"
                  type="departments"
                  :disabled="(!$store.state.access ? false : false)"
                />
              </v-col>
              <v-col md="1">
                <v-checkbox
                  v-model="admin"
                  class="mt-0"
                  :label="$t('admin')"
                  value="active"
                  :disabled="(!$store.state.admin ? true : false)"
                />
              </v-col>
              <v-col md="3">
                <v-checkbox
                  v-model="deactiveChangeSellPrice"
                  class="mt-0"
                  :label="$t('deactiveChangeSellPrice')"
                  value="active"
                  :disabled="(!$store.state.access ? true : false)"
                />
              </v-col>
              <v-col md="3">
                <v-checkbox
                  v-model="deactiveBranchAccess"
                  class="mt-0"
                  :label="$t('deactiveBranchAccess')"
                  value="active"
                  :disabled="(!$store.state.access ? true : false)"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-row class="pa-0 ma-0">
              <v-tabs
                vertical
              >
                <v-tab>
                  <v-icon class="me-3">
                    mdi-wordpress
                  </v-icon>
                  {{ $t('woocommerce') }}
                </v-tab>
                <v-tab align="right">
                  <v-icon class="me-3">
                    mdi-shopping-outline
                  </v-icon>
                  {{ $t('digikala') }}
                </v-tab>
                <v-tab align="right">
                  <v-icon class="me-3">
                    mdi-web
                  </v-icon>
                  {{ $t('portal') }}
                </v-tab>
                <v-tab align="right">
                  <img
                    width="20"
                    class="me-4"
                    src="@/assets/sazito.png"
                  >
                  {{ $t('sazito') }}
                </v-tab>
                <v-tab align="right">
                  <img
                    width="20"
                    class="me-4"
                    src="@/assets/webzi.png"
                  >
                  {{ $t('webzi') }}
                </v-tab>
                <v-tab-item>
                  <v-container>
                    <v-row class="mx-0">
                      <v-col
                        cols="6"
                        class="px-0"
                      >
                        <v-btn
                          color="primary"
                          class="mr-0"
                          outlined
                          :loading="isLoading"
                          @click="addWoocommerceIdItems"
                        >
                          {{ $t('addId') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="(item, h) in woocommerceIdItems"
                      :key="h"
                    >
                      <v-col
                        cols="12"
                        md="3"
                        class="mb-0"
                      >
                        <autocomplete
                          v-model="item.woocommercePanelName"
                          :title="$t('woocommercePanelName')"
                          :value="item.woocommercePanelName"
                          type="woocommercePanelName"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        class="mb-0"
                      >
                        <v-text-field
                          v-model="item.woocommerceId"
                          :label="$t('woocommerceId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="mb-0"
                      >
                        <v-btn
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeWoocommerceId(item)"
                        >
                          <v-icon>
                            mdi-trash-can-outline
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0  "
                      >
                        <v-text-field
                          v-model="digikalaId"
                          :label="$t('digikalaId')"
                          height="20"
                          dense
                          outlined
                          :disabled="true"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0  "
                      >
                        <v-text-field
                          v-model="portalId"
                          :label="$t('portalId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0  "
                      >
                        <v-text-field
                          v-model="sazitoId"
                          :label="$t('sazitoId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0  "
                      >
                        <v-text-field
                          v-model="webziId"
                          :label="$t('webziId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0  "
                      >
                        <v-checkbox
                          v-model="webziSeller"
                          class="mt-1  mx-3"
                          :label="$t('webziSeller')"
                          value="active"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-text-field
                          v-model="webziSellerCommission"
                          :label="$t('webziSellerCommission')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <file-picker
                ref="refFilePickerDocument"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="account"
                :val="(id && attachments ? attachments : null)"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Description from '../../components/general/description/Description'
  import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import filePicker from '../../components/general/filePicker/index'
  import customFields from '../../components/general/customFields/index.vue'
  export default {
    name: 'Customer',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Description,
      customFields,
      filePicker,
      aicomplete,
      Tag: () => import('../../components/general/Tag/tag'),
    },
    mixins: [General],
    props: ['idProp', 'returnObject'],
    data: () => ({
      webziSeller: null,
      webziSellerCommission: null,
      investorSellPercent: null,
      investorReturnSellPercent: null,
      visitorReturnSellPercent: null,
      panel: 5,
      personnelType: null,
      departmentAccess: null,
      customFields: null,
      attachments: null,
      deactiveBranchAccess: null,
      visitorSellPercent: null,
      reload: true,
      valid: true,
      gender: 'man',
      showPassword: false,
      deactiveChangeSellPrice: false,
      branchAccess: null,
      imagePicker: null,
      imagePickerVal: null,
      portalId: null,
      student: null,
      teacher: null,
      investor: null,
      visitor: null,
      translator: null,
      woocommerceId: null,
      woocommerceIdItems: [],
      sazitoId: null,
      webziId: null,
      digikalaId: null,
      role: null,
      admin: null,
      plan: null,
      category: null,
      entrepotAccess: null,
      initialCheck: true,
      username: null,
      avatar: null,
      password: null,
      tag: null,
      type: null,
      attractionMethod: null,
      lead: null,
      mobile: null,
      personel: null,
      status: 'active',
      nationalCode: null,
      content: null,
      firstname: null,
      birthDate: null,
      lastname: null,
      postalCode: null,
      currency: null,
      businessName: null,
      financialCode: null,
      phone: null,
      render: true,
      accountCategory: null,
      isLoading: false,
      country: null,
      state: null,
      stateWatch: false,
      countWoocommercepanel: 1,
      city: null,
      cityWatch: false,
      email: null,
      id: null,
      address: null,
      nature_initial_price: null,
      natureItems: null,
      initial_price: null,
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
    }),
    computed: {
      activeUser () {
        var active = false
        if (this.$store.state.permissions && this.$store.state.permissions.includes('usersList') && (this.student === 'active' || this.teacher === 'active' || this.translator === 'active' || this.personel)) {
          active = true
        }
        return active
      },
    },
    watch: {
      idProp () {
        this.render = true
        if (this.idProp != null) {
          this.id = this.idProp
          this.show()
          this.render = false
        } else {
          this.render = false
        }
      },
      initial_price (val) {
        if (val && parseFloat(val) > 0 && !this.nature) {
          this.nature = 'debtor'
        }
      },
      avatar () {
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.id = this.$route.params.id
        this.show()
        this.render = false
      }
      if (this.idProp != null) {
        this.id = this.idProp
        this.show()
        this.render = false
      }
    },
    mounted () {
      if (this.woocommerceIdItems.length === 0) {
        this.addWoocommerceIdItems()
      }
      this.natureItems = [
        {
          value: 'debtor',
          text: this.$t('debtor'),
        },
        {
          value: 'creditor',
          text: this.$t('creditor'),
        },
      ]
    },
    methods: {
      addWoocommerceIdItems () {
        if (this.$store.state.allConfig && this.$store.state.allConfig.countWoocommercePanel) {
          this.countWoocommercepanel = this.$store.state.allConfig.countWoocommercePanel
        }
        if (this.woocommerceIdItems.length < this.countWoocommercepanel) {
          var item = {
            woocommercePanelName: null,
            woocommerceId: null,
          }
          this.woocommerceIdItems.push(item)
        }
      },
      removeWoocommerceId (item) {
        var i = this.woocommerceIdItems.indexOf(item)
        this.woocommerceIdItems.splice(i, 1)
      },
      cancel () {
        if (!this.idProp && !this.returnObject) {
          if (this.lead === 'active') {
            this.goTo('leadList')
          } else {
            if (this.personel === 'active') {
              this.goTo('usersList')
            } else {
              this.goTo('customerList')
            }
          }
        } else {
          this.$emit('close')
        }
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'customer', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            if (app.imagePicker) {
              app.$refs.refFilePicker.create(res.data.data.id)
            }
            if (app.$refs.refFilePickerDocument !== undefined && app.attachments) {
              app.$refs.refFilePickerDocument.create(res.data.data.id)
            }
            app.$emit('input', res.data.data)
            // app.clearForm()
            app.cancel()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'customer/' + this.id, this.$data)
          .then(res => {
            res = res.data
            if (app.imagePicker) {
              app.$refs.refFilePicker.create(app.id)
            }
            if (app.$refs.refFilePickerDocument !== undefined) {
              app.$refs.refFilePickerDocument.create(app.id)
            }
            app.cancel()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'customer/' + this.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.id = res.id
              app.country = res.country
              app.address = res.address
              app.attachments = res.attachments
              app.state = res.state
              app.city = res.city
              app.imagePicker = res.avatar
              app.customFields = res.custom_fields
              app.imagePickerVal = res.avatar
              app.content = res.content
              app.firstname = res.firstname
              app.lastname = res.lastname
              app.gender = res.gender
              app.status = res.status
              app.branch = (res.meta ? res.meta.branch : null)
              app.personel = res.personel
              app.personnelType = res.personnelType
              app.departmentAccess = res.department_access
              app.category = res.category
              app.lead = res.lead
              app.email = res.email
              app.phone = res.phone
              app.mobile = res.mobile
              app.plan = (res.plan ? res.plan.plan : null)
              app.birthDate = res.birth_date
              app.admin = res.admin
              app.branchAccess = res.branchAccess
              app.entrepotAccess = res.entrepotAccess
              app.nationalCode = res.national_code
              app.financialCode = res.financial_code
              app.businessName = res.business_name
              app.postalCode = res.postal_code
              app.initialCheck = res.initialCheck
              app.attractionMethod = res.attraction_method
              app.nature_initial_price = res.nature_initial_price
              app.initial_price = res.initial_price
              app.role = res.role
              app.username = res.username
              app.portalId = res.integrator.portalId
              app.woocommerceIdItems = res.woocommerceIdItems
              app.sazitoId = res.integrator.sazitoId
              app.webziId = res.integrator.webziId
              app.webziSeller = res.integrator.webziSeller
              app.webziSellerCommission = res.integrator.webziSellerCommission
              app.digikalaId = res.integrator.digikalaId
              app.deactiveChangeSellPrice = (res.integrator ? res.integrator.deactiveChangeSellPrice : null)
              app.deactiveBranchAccess = (res.integrator ? res.integrator.deactiveBranchAccess : null)
              app.student = (res.integrator ? res.integrator.student : null)
              app.teacher = (res.integrator ? res.integrator.teacher : null)
              app.visitor = (res.integrator ? res.integrator.visitor : null)
              app.investor = (res.integrator ? res.integrator.investor : null)
              app.visitorSellPercent = (res.integrator ? res.integrator.visitorSellPercent : null)
              app.visitorReturnSellPercent = (res.integrator ? res.integrator.visitorReturnSellPercent : null)
              app.investorSellPercent = (res.integrator ? res.integrator.investorSellPercent : null)
              app.investorReturnSellPercent = (res.integrator ? res.integrator.investorReturnSellPercent : null)
              app.translator = (res.integrator ? res.integrator.translator : null)
              if (res.tags) {
                app.tag = res.tags
                app.more = true
              }
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearForm () {
        this.valid = true
        this.gender = 'man'
        this.showPassword = false
        this.attachments = null
        this.role = null
        this.category = null
        this.username = null
        this.avatar = null
        this.password = null
        this.tag = null
        this.type = null
        this.attractionMethod = null
        this.lead = null
        this.mobile = null
        this.personel = null
        this.status = 'active'
        this.nationalCode = null
        this.content = null
        this.firstname = null
        this.birthDate = null
        this.lastname = null
        this.postalCode = null
        this.currency = null
        this.businessName = null
        this.financialCode = null
        this.phone = null
        this.accountCategory = null
        this.isLoading = false
        this.country = null
        this.state = null
        this.stateWatch = false
        this.city = null
        this.cityWatch = false
        this.email = null
        this.id = null
        this.address = null
        this.nature_initial_price = null
        this.initial_price = null
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
